import LeadForm from "@/components/LeadForm";
import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import { PHONES, EMAIL, WHATSAPP } from "@/lib/api";

export default function Contact() {
  const wa = `https://wa.me/${WHATSAPP}?text=${encodeURIComponent("Hello, I'd like to enquire about plots at Shujalpur.")}`;

  return (
    <div className="bg-[#0a0a0b] text-white pt-32">
      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-16" data-testid="contact-hero">
        <p className="label-overline">Contact</p>
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl mt-5 tracking-tight leading-[1.05] max-w-4xl">
          Let's begin <span className="italic text-[#c5a059]">your land story</span>.
        </h1>
        <p className="text-[#cfcfd2] mt-8 max-w-2xl leading-relaxed">
          Our team is available 7 days a week. Reach out by phone, WhatsApp, or email — we'll
          respond promptly with layout details and answer any questions.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-12 pb-24 grid lg:grid-cols-12 gap-8">
        <div className="lg:col-span-5 space-y-4">
          {/* Phones card */}
          <div data-testid="contact-call-us" className="card-hover flex items-start gap-5 bg-[#0f0f11] border border-[#2a2a2d] rounded-xl p-6">
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-[#c5a059]/40 text-[#c5a059] flex-shrink-0">
              <Phone size={18} strokeWidth={1.4} />
            </span>
            <div className="flex-1">
              <p className="label-overline">Call Us</p>
              <div className="mt-2 flex flex-col gap-1.5">
                {PHONES.map((p, i) => (
                  <a
                    key={p.tel}
                    href={`tel:${p.tel}`}
                    data-testid={`contact-phone-${i}`}
                    className="text-white hover:text-[#c5a059] transition"
                  >
                    {p.display}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {[
            { icon: MessageCircle, t: "WhatsApp", v: PHONES[0].display, href: wa, target: "_blank" },
            { icon: Mail, t: "Email", v: EMAIL, href: `mailto:${EMAIL}` },
            { icon: MapPin, t: "Site Office", v: "Freeganj, Ashta Road, Shujalpur, MP 465333", href: "https://maps.app.goo.gl/p6Ca7LpS7cJfHEqG9", target: "_blank" },
          ].map(({ icon: Icon, t, v, href, target }) => (
            <a
              key={t}
              href={href || "#"}
              target={target}
              rel={target ? "noopener noreferrer" : undefined}
              data-testid={`contact-${t.toLowerCase().replace(" ", "-")}`}
              className="card-hover flex items-start gap-5 bg-[#0f0f11] border border-[#2a2a2d] rounded-xl p-6"
            >
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-[#c5a059]/40 text-[#c5a059] flex-shrink-0">
                <Icon size={18} strokeWidth={1.4} />
              </span>
              <div>
                <p className="label-overline">{t}</p>
                <p className="text-white mt-2">{v}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="lg:col-span-7">
          <LeadForm />
        </div>
      </section>
    </div>
  );
}
